module.exports = __webpack_public_path__ + "media/images/icons/icons_large/58_ring-7ccc020fa7853e8e8e2863b3087b9cc2.png";